import { memo } from 'react'

import { useQuery } from '@tanstack/react-query'

import { LoadingIndicator } from '@shared/layouts'
import { PageError } from 'layouts'
import { eventConfigRoute } from 'pages/NWPlatform/Workspaces/Workspace/Events/Event'
import { eventQueryKeys } from 'services/queryKeys'

import { ConfigForm } from './ConfigForm'

const ConfigEditorRaw = () => {
  const { eventId } = eventConfigRoute.useParams()

  const eventQuery = useQuery(eventQueryKeys.detail({ eventId }))

  if (eventQuery.isLoading) {
    return <LoadingIndicator />
  }

  if (eventQuery.isSuccess && eventQuery.data.config) {
    return <ConfigForm event={eventQuery.data} config={eventQuery.data.config} />
  }

  return <PageError />
}

export const ConfigEditor = memo(ConfigEditorRaw)
